// removed by extract-text-webpack-plugin
module.exports = {"root":"_1JEBxrpd0dhzMP2FXx-oiS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/icon.scss
// module id = 1196
// module chunks = 0